import React from 'react';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { AppearanceProvider } from './theme/AppearanceContext';
import { ThemeProvider } from './theme/ThemeContext';
import { getGoogleClientId } from './config/google';
import GuestRoute from './components/auth/GuestRoute';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthHomeRedirect from './components/auth/AuthHomeRedirect';
import Deeplink from './pages/deeplink';
import AppAddTxt from './pages/app-add-txt/index';
import Login from './pages/login';
import PanelGate from './components/auth/PanelGate';
import AppPage from './pages/app';
import ArticlesPage, { PublicArticles } from './pages/articles';
import StationaryPage from './pages/stationary';
import PlaylistPage from './pages/playlist';
import WhatsNewPage from './pages/whats-new';
import HelpQueryPage from './pages/help-query';
import AnalyticsPage from './pages/analytics';
import DevicesPage from './pages/devices';
import CoinUsagePage from './pages/coins';
import JoystickPage from './pages/joystick';
import ItineraryPage from './pages/itinerary';
import NotificationsPage from './pages/notifications';
import AccountPage from './pages/account';
import BackupPage from './pages/backup';
import SettingsHome from './pages/settings/SettingsHome';
import ThemeSettingsPage from './pages/settings/ThemeSettingsPage';
import LanguageSettings from './pages/settings/LanguageSettings';
import AppDefaultsPage from './pages/settings/AppDefaultsPage';
import AppDefaultCategoryPage from './pages/settings/AppDefaultCategory';
import {
  HelpPage,
  LocationHistoryPage,
} from './pages/modules/module-placeholder';

const AppRoutes = () => (
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthHomeRedirect />} />
        <Route path="/app-ads.txt" element={<AppAddTxt />} />
        <Route path="/dl-stpoint" element={<Deeplink />} />
        <Route path="/dl-playlist-points" element={<Deeplink />} />
        <Route path="/dl-itinerary" element={<Deeplink />} />
        <Route path="/dl-reset-password" element={<Deeplink />} />
        <Route path="/articles" element={<PublicArticles />} />
        <Route
          path="/login"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <PanelGate />
            </ProtectedRoute>
          }
        >
          <Route index element={<AppPage />} />
          <Route path="stationary" element={<StationaryPage />} />
          <Route path="playlist" element={<PlaylistPage />} />
          <Route path="itinerary" element={<ItineraryPage />} />
          <Route path="articles" element={<ArticlesPage embedded />} />
          <Route path="joystick" element={<JoystickPage />} />
          <Route path="location-history" element={<LocationHistoryPage />} />
          <Route path="coin-usage" element={<CoinUsagePage />} />
          <Route path="devices" element={<DevicesPage />} />
          <Route path="drive-backup" element={<BackupPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="whats-new" element={<WhatsNewPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="account" element={<AccountPage />} />
          <Route path="queries" element={<HelpQueryPage />} />
          <Route path="settings" element={<SettingsHome />} />
          <Route path="settings/theme" element={<ThemeSettingsPage />} />
          <Route path="settings/language" element={<LanguageSettings />} />
          <Route path="settings/app-defaults" element={<AppDefaultsPage />} />
          <Route path="settings/app-defaults/:category" element={<AppDefaultCategoryPage />} />
          <Route path="help" element={<HelpPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

const App = () => {
  const googleClientId = getGoogleClientId();
  const routes = googleClientId ? (
    <GoogleOAuthProvider clientId={googleClientId}>
      <AppRoutes />
    </GoogleOAuthProvider>
  ) : (
    <AppRoutes />
  );

  return (
    <LanguageProvider>
      <ThemeProvider>
        <AppearanceProvider>{routes}</AppearanceProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
};

export default App;
